import React, { useState } from "react";
import styled from "styled-components/macro";
import { rgba } from "polished";
import { NavLink, withRouter } from "react-router-dom";
import { darken } from "polished";
import PerfectScrollbar from "react-perfect-scrollbar";
import "../vendor/perfect-scrollbar.css";
import { useDispatch, useTrackedState } from "../system/store";
import { useSharedState } from "../pages/agi/store";
import { useAuth0 } from "@auth0/auth0-react";
import { Menu as MenuIcon, MicNone, RouterRounded } from "@material-ui/icons";
import { spacing } from "@material-ui/system";
import { makeStyles } from "@material-ui/core/styles";
import {
  Badge,
  Box as MuiBox,
  Chip,
  Grid,
  Avatar,
  IconButton as MuiIconButton,
  Collapse,
  Drawer as MuiDrawer,
  List as MuiList,
  ListItem,
  ListItemText,
  Typography,
  Button,
} from "@material-ui/core";

import { ExpandLess, ExpandMore } from "@material-ui/icons";

import { green } from "@material-ui/core/colors";

import { sidebarRoutes as routesInit } from "../routes/index";

import { ReactComponent as Logo } from "../vendor/logo.svg";

import bmrlogo from "../assets/platform_logo.svg";

import DeveloperBoardIcon from "@material-ui/icons/DeveloperBoard";

const useStyles = makeStyles((theme) => ({
  blueText: {
    color: "blue !important",
  },
}));

const SidebarCategory = ({
  name,
  icon,
  isOpen,
  isCollapsable,
  badge,
  color,
  ...rest
}) => {
  return (
    <Category {...rest}>
      {icon}
      <CategoryText>
        {name}
        {color}
      </CategoryText>
      {isCollapsable ? (
        isOpen ? (
          <CategoryIconMore />
        ) : (
          <CategoryIconLess />
        )
      ) : null}
      {badge ? <CategoryBadge label={badge} /> : ""}
    </Category>
  );
};

const SidebarLink = ({ name, to, badge, icon, color }) => {
  const dispatch = useDispatch();
  const { page } = useTrackedState();
  var textStyle = {
    color: null,
  };
  if (color == "blue") {
    textStyle = {
      color: "#a3cbe8",
    };
  }
  return (
    <Link
      button
      dense
      onClick={() => {
        dispatch({ type: "SET_PAGE", page: to });
      }}
      selected={page === to}
    >
      <LinkText>
        <span style={textStyle}>{name}</span>
      </LinkText>
      {badge ? <LinkBadge label={badge} /> : ""}
    </Link>
  );
};

const Sidebar = ({
  onDrawerToggle,
  classes,
  staticContext,
  location,
  ...rest
}) => {
  const { user, available_tools } = useTrackedState();
  const { isAuthenticated } = useAuth0();
  const dispatch = useDispatch();
  const [state, setState] = useSharedState();

  const routes = routesInit.map((route) => {
    if (route.id === "AGI") {
      return {
        ...route,
        children: route.children.filter((child) => {
          if (child.name === "Project") {
            return state.project.name;
          } else if (
            [
              "Dashboard",
              // "Extraction",
              // "Download Excel",
              // "Download Excel Pivot",
            ].includes(child.name)
          ) {
            return state.project.data.length;
          } else {
            return true;
          }
        }),
      };
    } else {
      return route;
    }
  });

  const initOpenRoutes = () => {
    /* Open collapse element that matches current url */
    const pathName = location.pathname;

    let _routes = {};

    routes.forEach((route, index) => {
      const isActive = pathName.indexOf(route.path) === 0;
      const isOpen = route.open;
      const isHome = route.containsHome && pathName === "/";

      _routes = Object.assign({}, _routes, {
        [index]: isActive || isOpen || isHome,
      });
    });

    return _routes;
  };

  const [openRoutes, setOpenRoutes] = useState(() => initOpenRoutes());

  const toggle = (index) => {
    // Collapse all elements
    Object.keys(openRoutes).forEach(
      (item) =>
        openRoutes[index] ||
        setOpenRoutes((openRoutes) =>
          Object.assign({}, openRoutes, { [item]: false })
        )
    );

    // Toggle selected element
    setOpenRoutes((openRoutes) =>
      Object.assign({}, openRoutes, { [index]: !openRoutes[index] })
    );
  };

  // console.log(routes);
  return (
    <Drawer variant="permanent" {...rest}>
      {/* <IconButton
        color="inherit"
        aria-label="Open drawer"
        onClick={onDrawerToggle}
      >
        <MenuIcon />
      </IconButton> */}
      <Brand component={NavLink} to="/" button>
        <img src={bmrlogo} width={40} /> <Box ml={1}>Bright Platform</Box>
      </Brand>
      <Scrollbar>
        <List>
          {isAuthenticated && user ? (
            <Items>
              {routes.map((category, index) => (
                <React.Fragment key={index}>
                  {(available_tools.find((a) => a.code === category.tool_id) ||
                    category.tool_id === undefined ||
                    (category.tool_id === "administration" &&
                      user.role !== "user")) && (
                    <React.Fragment>
                      {category.header ? (
                        <SidebarSection>{category.header}</SidebarSection>
                      ) : null}
                      {category.children && category.icon ? (
                        <React.Fragment key={index}>
                          <SidebarCategory
                            isOpen={!openRoutes[index]}
                            isCollapsable={true}
                            name={category.id}
                            icon={category.icon}
                            button={true}
                            onClick={() => toggle(index)}
                          />

                          <Collapse
                            in={openRoutes[index]}
                            timeout="auto"
                            unmountOnExit
                          >
                            {category.children.map((route, index) => (
                              <React.Fragment key={index}>
                                {((route.visible !== false &&
                                  route.visible !== "superadmin") ||
                                  (user.role === "superadmin" &&
                                    route.visible === "superadmin")) && (
                                  <SidebarLink
                                    name={route.name}
                                    to={route.path}
                                    icon={route.icon}
                                    badge={route.badge}
                                    color={route.color}
                                  />
                                )}
                              </React.Fragment>
                            ))}
                          </Collapse>
                        </React.Fragment>
                      ) : category.icon ? (
                        <SidebarCategory
                          isCollapsable={false}
                          name={category.id}
                          to={category.path}
                          activeClassName="active"
                          component={NavLink}
                          icon={category.icon}
                          color={category.color}
                          // exact
                          button
                          badge={category.badge}
                        />
                      ) : null}
                    </React.Fragment>
                  )}
                </React.Fragment>
              ))}
              {/* Hardcoded KIWI */}
              <React.Fragment>
                <SidebarCategory
                  isOpen={false}
                  isCollapsable={false}
                  name={"Bright KIWI"}
                  icon={<DeveloperBoardIcon />}
                  button={true}
                  onClick={() => {
                    window.open(
                      "https://genai-doc-builder.web.app/",
                      "_blank",
                      "noopener,noreferrer"
                    );
                  }}
                />
              </React.Fragment>
              {/* Hardcoded KIWI */}
            </Items>
          ) : null}
        </List>
      </Scrollbar>

      {isAuthenticated && user ? (
        <>
          <SidebarFooter>
            <Grid container spacing={2}>
              <Grid item>
                <SidebarFooterBadge overlap="circle" variant="dot">
                  <Avatar>
                    {user.email ? user.email.charAt(0).toUpperCase() : null}
                  </Avatar>
                </SidebarFooterBadge>
              </Grid>
              <Button
                onClick={() => {
                  dispatch({ type: "USER_PAGE", user_id: user.id });
                }}
              >
                <Grid item>
                  <SidebarFooterText variant="body2">
                    {user.email}
                  </SidebarFooterText>
                  <SidebarFooterSubText variant="caption">
                    {user.role}
                  </SidebarFooterSubText>
                </Grid>
              </Button>
            </Grid>
          </SidebarFooter>
        </>
      ) : null}
    </Drawer>
  );
};

const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
`;

const Box = styled(MuiBox)(spacing);

const Drawer = styled(MuiDrawer)`
  border-right: 0;

  > div {
    border-right: 0;
  }
`;

const Scrollbar = styled(PerfectScrollbar)`
  background-color: ${(props) => props.theme.sidebar.background};
  border-right: 1px solid rgba(0, 0, 0, 0.12);
`;

const List = styled(MuiList)`
  background-color: ${(props) => props.theme.sidebar.background};
`;

const Items = styled.div`
  padding-top: ${(props) => props.theme.spacing(2.5)}px;
  padding-bottom: ${(props) => props.theme.spacing(2.5)}px;
`;

const Brand = styled(ListItem)`
  font-size: ${(props) => props.theme.typography.h5.fontSize};
  font-weight: ${(props) => props.theme.typography.fontWeightMedium};
  color: ${(props) => props.theme.sidebar.header.color};
  background-color: ${(props) => props.theme.sidebar.header.background};
  font-family: ${(props) => props.theme.typography.fontFamily};
  min-height: 56px;
  padding-left: ${(props) => props.theme.spacing(6)}px;
  padding-right: ${(props) => props.theme.spacing(6)}px;
  justify-content: center;
  cursor: pointer;

  ${(props) => props.theme.breakpoints.up("sm")} {
    min-height: 64px;
  }

  &:hover {
    background-color: ${(props) => props.theme.sidebar.header.background};
  }
`;

const BrandIcon = styled(Logo)`
  margin-right: ${(props) => props.theme.spacing(2)}px;
  color: ${(props) => props.theme.sidebar.header.brand.color};
  fill: ${(props) => props.theme.sidebar.header.brand.color};
  width: 32px;
  height: 32px;
`;

const BrandChip = styled(Chip)`
  background-color: ${green[700]};
  border-radius: 5px;
  color: ${(props) => props.theme.palette.common.white};
  font-size: 55%;
  height: 18px;
  margin-left: 2px;
  margin-top: -16px;
  padding: 3px 0;

  span {
    padding-left: ${(props) => props.theme.spacing(1.375)}px;
    padding-right: ${(props) => props.theme.spacing(1.375)}px;
  }
`;

const Category = styled(ListItem)`
  padding-top: ${(props) => props.theme.spacing(3)}px;
  padding-bottom: ${(props) => props.theme.spacing(3)}px;
  padding-left: ${(props) => props.theme.spacing(8)}px;
  padding-right: ${(props) => props.theme.spacing(7)}px;
  font-weight: ${(props) => props.theme.typography.fontWeightRegular};

  svg {
    color: ${(props) => props.theme.sidebar.color};
    font-size: 20px;
    width: 20px;
    height: 20px;
    opacity: 0.5;
  }

  &:hover {
    background: rgba(0, 0, 0, 0.08);
  }

  &.${(props) => props.activeClassName} {
    background-color: ${(props) =>
      darken(0.03, props.theme.sidebar.background)};

    span {
      color: ${(props) => props.theme.sidebar.color};
    }
  }
`;

const CategoryText = styled(ListItemText)`
  margin: 0;
  span {
    color: ${(props) => props.theme.sidebar.color};
    font-size: ${(props) => props.theme.typography.body1.fontSize}px;
    padding: 0 ${(props) => props.theme.spacing(4)}px;
  }
`;

const CategoryIconLess = styled(ExpandLess)`
  color: ${(props) => rgba(props.theme.sidebar.color, 0.5)};
`;

const CategoryIconMore = styled(ExpandMore)`
  color: ${(props) => rgba(props.theme.sidebar.color, 0.5)};
`;

const Link = styled(ListItem)`
  padding-left: ${(props) => props.theme.spacing(17.5)}px;
  padding-top: ${(props) => props.theme.spacing(2)}px;
  padding-bottom: ${(props) => props.theme.spacing(2)}px;

  span {
    color: ${(props) => rgba(props.theme.sidebar.color, 0.7)};
  }

  &:hover span {
    color: ${(props) => rgba(props.theme.sidebar.color, 0.9)};
  }

  &:hover {
    background-color: ${(props) =>
      darken(0.015, props.theme.sidebar.background)};
  }

  &.${(props) => props.activeClassName} {
    background-color: ${(props) =>
      darken(0.03, props.theme.sidebar.background)};

    span {
      color: ${(props) => props.theme.sidebar.color};
    }
  }
`;

const LinkText = styled(ListItemText)`
  color: ${(props) => props.theme.sidebar.color};
  span {
    font-size: ${(props) => props.theme.typography.body1.fontSize}px;
  }
  margin-top: 0;
  margin-bottom: 0;
`;

const LinkBadge = styled(Chip)`
  font-size: 11px;
  font-weight: ${(props) => props.theme.typography.fontWeightBold};
  height: 20px;
  position: absolute;
  right: 28px;
  top: 8px;
  background: ${(props) => props.theme.sidebar.badge.background};

  span.MuiChip-label,
  span.MuiChip-label:hover {
    cursor: pointer;
    color: ${(props) => props.theme.sidebar.badge.color};
    padding-left: ${(props) => props.theme.spacing(2)}px;
    padding-right: ${(props) => props.theme.spacing(2)}px;
  }
`;

const CategoryBadge = styled(LinkBadge)`
  top: 12px;
`;

const SidebarSection = styled(Typography)`
  color: ${(props) => props.theme.sidebar.color};
  padding: ${(props) => props.theme.spacing(4)}px
    ${(props) => props.theme.spacing(7)}px
    ${(props) => props.theme.spacing(1)}px;
  opacity: 0.9;
  display: block;
`;

const SidebarFooter = styled.div`
  background-color: ${(props) =>
    props.theme.sidebar.footer.background} !important;
  padding: ${(props) => props.theme.spacing(2.75)}px
    ${(props) => props.theme.spacing(4)}px;
  border-right: 1px solid rgba(0, 0, 0, 0.12);
`;

const SidebarFooterText = styled(Typography)`
  color: ${(props) => props.theme.sidebar.footer.color};
`;

const SidebarFooterSubText = styled(Typography)`
  color: ${(props) => props.theme.sidebar.footer.color};
  font-size: 0.7rem;
  display: block;
  padding: 1px;
`;

const SidebarFooterBadge = styled(Badge)`
  margin-right: ${(props) => props.theme.spacing(1)}px;
  span {
    background-color: ${(props) =>
      props.theme.sidebar.footer.online.background};
    border: 1.5px solid ${(props) => props.theme.palette.common.white};
    height: 12px;
    width: 12px;
    border-radius: 50%;
  }
`;

export default withRouter(Sidebar);
